import React, {Component} from "react";
import {
  Input
} from 'antd';
import _ from "i18n";
import {formatAmount} from "../../../services/utils";

export default class EnterAmount extends Component {
  render() {
    return(
    <div className={"flex items-center"} style={{"padding": "1.5rem", "height": "100%"}}>
      <div className={"user-card-container w-full"}>
        <div
          className={"m-3"}>{_("MANGO_WALLET_BALANCE") + formatAmount(this.props.amount)}</div>
        <div
          className={"mb-3 mr-3 ml-3"}>{_("ENTER_AMOUNT_FOR_MANGO_WALLET")}</div>
        <div className="payment-with-card mb-3">
          <div className={"new-card-amount-input flex justify-center"}>
            <Input
              value={this.props.value}
              onChange={this.props.onChange}
              className={"new-card-input"}
              suffix={"€"}
              style={{"width": "150px"}}
            />
          </div>
        </div>
      </div>
    </div>
    );
  }
}




// WEBPACK FOOTER //
// ./app/components/Admin/FeedMangoWallet/EnterAmount.js